import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "decor-title__icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "decor-title__text",
  style: {"background":"url('/images/decor-title-bg.svg') 100% no-repeat","background-size":"contain","background-position":"left"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorTitle',
  props: {
    title: {},
    icon: {},
    small: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["decor-title", { 'decor-title--small': _ctx.small }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.icon,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
  ], 2))
}
}

})